import type { MrrMovementChartDataPoint } from './types';

export function trimEmptyEdges(
  data: MrrMovementChartDataPoint[],
): MrrMovementChartDataPoint[] {
  let firstActive = -1;
  let lastActive = -1;

  for (let i = 0; i < data.length; i++) {
    if (hasActivity(data[i])) {
      if (firstActive === -1) firstActive = i;
      lastActive = i;
    }
  }

  if (firstActive === -1) {
    return [];
  }

  const padStart = Math.max(firstActive - 1, 0);
  const padEnd = Math.min(lastActive + 2, data.length);

  return data.slice(padStart, padEnd);
}

function hasActivity(point: MrrMovementChartDataPoint): boolean {
  return (
    point.new !== 0
    || point.expansion !== 0
    || point.reactivation !== 0
    || point.contraction !== 0
    || point.churn !== 0
  );
}
